import ReactMarkdown from 'react-markdown';
import { MapPin } from 'lucide-react';
import nodesPreviewRaw from '../content/nodes-preview.md?raw';

/**
 * Nodes page: renders the Node Scripts Preview (10 nodes 2016–2025).
 * Source: docs/whitepaper/Nodes-Preview.md (copied to src/content for build).
 */
export default function NodesPage() {
  return (
    <div className="min-h-screen pt-24 pb-20 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <MapPin className="w-10 h-10 text-purple-400" aria-hidden />
          <h1 className="text-4xl font-bold text-white">Time-Travel Nodes — Preview</h1>
        </div>
        <div className="bg-slate-800/50 border border-purple-500/30 rounded-xl p-8 md:p-10 markdown-content">
          <ReactMarkdown>{nodesPreviewRaw}</ReactMarkdown>
        </div>
        <div className="mt-8 flex flex-wrap gap-4">
          <a
            href="/Nodes-Preview.pdf"
            className="inline-flex items-center gap-2 px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
            download
          >
            Download PDF (Preview)
          </a>
          <a
            href="https://discord.gg/rRBSnQsxJu"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-slate-600 text-white rounded-lg hover:bg-slate-500 transition-colors"
          >
            Join Discord for full 200-page node scripts
          </a>
        </div>
      </div>
    </div>
  );
}
